import {
  GQLAccessory,
  GQLAccessoryConfiguration,
  GQLAccessoryReference,
  GQLAccessorySize,
  GQLMaterialType,
  GQLPlatingType
} from '@jewelutions/core-crm-server-api-client-domain';

export class GQLAccessoryHelper {
  static getAllAvailableAccessoryConfigurations(accessory: GQLAccessory): GQLAccessoryConfiguration[] {
    if (accessory.models.length === 0) {
      return [];
    }
    return accessory.models.map(m => m.availableConfigurations).reduce((c1, c2) => c1.concat(c2));
  }
}

export class GQLAccessoryReferenceHelper {
  static identical(c1: GQLAccessoryReference, c2: GQLAccessoryReference): boolean {
    return (
      c1.accessoryId === c2.accessoryId &&
      c1.accessoryModelId === c2.accessoryModelId &&
      GQLAccessoryConfigurationHelper.identical(c1.accessoryConfiguration, c2.accessoryConfiguration)
    );
  }
}

export class GQLAccessoryConfigurationHelper {
  static getAvailablePlatingTypes(accessoryConfigurations: GQLAccessoryConfiguration[]): Set<GQLPlatingType> {
    const platingTypes = new Set<GQLPlatingType>();
    for (const pc of accessoryConfigurations) {
      platingTypes.add(pc.platingType!);
    }
    return platingTypes;
  }

  static getAvailableSizes(accessoryConfigurations: GQLAccessoryConfiguration[]): Set<GQLAccessorySize> {
    const pieceSizes = new Set<GQLAccessorySize>();
    for (const pc of accessoryConfigurations) {
      pieceSizes.add(pc.sizeType);
    }
    return pieceSizes;
  }

  static getAvailableMaterialTypes(
    accessoryConfigurations: GQLAccessoryConfiguration[]
  ): Set<GQLMaterialType> {
    const materialTypes = new Set<GQLMaterialType>();
    for (const pc of accessoryConfigurations) {
      materialTypes.add(pc.materialType);
    }
    return materialTypes;
  }

  static identical(c1: GQLAccessoryConfiguration, c2: GQLAccessoryConfiguration): boolean {
    return (
      c1.sizeType === c2.sizeType && c1.materialType === c2.materialType && c1.platingType === c2.platingType
    );
  }
}
